import { FC, useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {Link, useNavigate, useSearchParams} from "react-router-dom";

import HubInputField from "../../components/inputType";

import { resetpasswordSchema } from "../../validation/resetPassword";
import useFetch from "../../hooks/useFetch";
import { APIEndpoints } from "../../types/apiTypes";
import { ResetPasswordAPISuccessResponseType } from "./types";
import { ToastContext } from "../../context/toastContext";
import { ToastTypes } from "../../types";
import ZilrettaLogo from "../../assets/images/zilrettaLogo.png";
import IoveraLogo from "../../assets/images/iovera-logo.svg";
import FooterText from "../../components/footerText";



const HubResetPassword: FC = (): JSX.Element => {
  const [resetToken, setResetToken] = useState<string>('');
  const [searchParams] = useSearchParams();

  const { showToast } = useContext(ToastContext);
  const navigate = useNavigate();
  const { control, handleSubmit } = useForm({
    mode: 'all',
    resolver: yupResolver(resetpasswordSchema),
  });





  const { loading, data, error, removeErrorAndData, mutate } = useFetch<ResetPasswordAPISuccessResponseType>(APIEndpoints.USER_RESET_PASSWORD);

  useEffect(() => {
    const obj = new URLSearchParams(searchParams);
    setResetToken(obj.get('reset_password_token') || '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (data) {
      const { message } = data;
      showToast([message], ToastTypes.SUCCESS);
      navigate("/users/sign_in");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const submitPassword = async (values: { password: string, confirmPassword: string }) => {
    if ((error && error.length > 0) || data) removeErrorAndData();
    mutate({ user: { reset_password_token: resetToken, ...values } });
  };

  return (
    <div className="login-sec pt-3 d-flex flex-fill flex-column justify-content-between overflow-auto">
        <div className="container d-flex flex-fill">
            <div className="row flex-fill mt-lg-5">
                <div className="col-lg-8 col-md-6 col-12">
                    <div className="products-logos gap-3 gap-lg-5 mb-3 mb-lg-0">
                        <img className="zilretta-logo" src={ZilrettaLogo} alt="ZilrettaLogo"/>
                        <img className="iovera-logo" src={IoveraLogo} alt="HeroImage"/>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-12">
                    <form className="login-box bg-white rounded-3 p-4 shadow-lg" onSubmit={handleSubmit(submitPassword)}>
                        <h3 className="mb-3 fw-medium">Reset Password</h3>
                        <div>
                            <Controller
                                name="password"
                                control={control}
                                defaultValue=''
                                render={({ field, fieldState: { error } }) => (
                                    <HubInputField
                                        inputId="password"
                                        isRowBased={false}
                                        isRequired={true}
                                        field={field}
                                        error={error}
                                        inputLabel="New Password"
                                        inputType="password"
                                    />
                                )}
                            />
                            <Controller
                                name="confirmPassword"
                                control={control}
                                defaultValue=''
                                render={({ field, fieldState: { error } }) => (
                                    <HubInputField
                                        inputId="confirmPassword"
                                        isRowBased={false}
                                        isRequired={true}
                                        field={field}
                                        error={error}
                                        inputLabel="Confirm Password"
                                        inputType="password"
                                    />
                                )}
                            />
                        </div>
                        <div>
                            <div className="d-flex justify-content-between align-items-center">
                                <button disabled={loading} className="btn btn-primary" type="submit">
                                    <div className="row align-items-center px-1">
                                        {loading ? (
                                            <div className="spinner-border text-light col-3" role="status">
                                                <span className="sr-only"></span>
                                            </div>
                                        ) : null}
                                        <p className="col-auto mb-0"> Reset Password </p>
                                    </div>
                                </button>
                            </div>
                            <p className="small mt-3 mb-0 text-center">
                                By clicking Log in, you agree to our &nbsp;
                                <a href="https://www.pacira.com/terms-of-use/" target="_blank" rel="noreferrer">
                                    Terms of Use
                                </a>
                            </p>
                        </div>
                    </form>
                </div>
            </div>
      </div>
        <FooterText footerType="black"/>
    </div>
  );
};

export default HubResetPassword;
